import { useSyncExternalStore } from "react";

export interface UnfulfilledDemandCellPopoverTarget {
  /** The clicked cell element — popover anchor and outline host. */
  anchorEl: HTMLElement;
  sku: string;
  /** null = SKU-level (aggregate across all locations). */
  location: string | null;
  /** Epoch ms of the clicked date column (the matrix period start). */
  periodStartMs: number;
  dateHierarchy: "day" | "week" | "month";
}

// Module-level store so matrix cells can open the popover without threading
// props (or state) through MUIFlatTable / the chunked table builder. Opening
// and closing re-renders ONLY subscribers (the popover itself) — the table's
// props never change, so react-virtuoso repaints zero cells. Same contract as
// po_cell_popover/store.
let currentTarget: UnfulfilledDemandCellPopoverTarget | null = null;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function openUnfulfilledDemandCellPopover(
  target: UnfulfilledDemandCellPopoverTarget
): void {
  currentTarget = target;
  emit();
}

export function closeUnfulfilledDemandCellPopover(): void {
  if (currentTarget === null) return;
  currentTarget = null;
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): UnfulfilledDemandCellPopoverTarget | null {
  return currentTarget;
}

export function useUnfulfilledDemandCellPopoverTarget(): UnfulfilledDemandCellPopoverTarget | null {
  return useSyncExternalStore(subscribe, getSnapshot);
}
